if (!customElements.get('atb-toast')) {
  customElements.define(
    'atb-toast',
    class AtbToast extends HTMLElement {
      static DURATION = { v1: 3000, v2: 7000 };

      connectedCallback() {
        this.panel = this.querySelector('.atb-toast__panel');
        this.status = this.querySelector('[data-atb-toast-status]');
        this.image = this.querySelector('[data-atb-toast-image]');
        this.productTitle = this.querySelector('[data-atb-toast-title]');
        this.options = this.querySelector('[data-atb-toast-options]');
        this.price = this.querySelector('[data-atb-toast-price]');
        this.count = this.querySelector('[data-atb-toast-count]');
        this.total = this.querySelector('[data-atb-toast-total]');

        this.onPointerDown = this.onPointerDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);

        this.querySelector('[data-atb-toast-close]').addEventListener('click', () => {
          this.track('close');
          this.hide();
        });
        this.querySelector('[data-atb-toast-view]').addEventListener('click', () => {
          this.track('view_bag');
          this.hide();
          document.querySelector('cart-drawer')?.open();
        });
        this.querySelector('[data-atb-toast-checkout]').addEventListener('click', () => this.track('checkout'));

        this.panel.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse') clearTimeout(this.timer);
        });
        this.panel.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'mouse' && this.isOpen()) this.startTimer();
        });
        this.panel.addEventListener('focusin', () => clearTimeout(this.timer));
        this.panel.addEventListener('focusout', (event) => {
          if (this.isOpen() && !this.panel.contains(event.relatedTarget)) this.startTimer();
        });
      }

      show(parsedState) {
        const arm = document.documentElement.dataset.atbToast;
        if (!AtbToast.DURATION[arm] || document.querySelector('cart-drawer.active')) return false;

        const item = parsedState.items ? parsedState.items[0] : parsedState;
        if (!item || !item.product_title) return false;

        this.dataset.arm = arm;
        this.render(item);
        this.position();
        this.classList.add('is-open');
        this.status.textContent = `${this.querySelector('#AtbToast-Heading').textContent}: ${item.product_title}`;

        document.addEventListener('pointerdown', this.onPointerDown);
        document.addEventListener('keyup', this.onKeyUp);
        this.startTimer();
        this.track('view');
        return true;
      }

      hide() {
        clearTimeout(this.timer);
        if (!this.isOpen()) return;

        if (this.panel.contains(document.activeElement)) {
          document.querySelector('cart-drawer')?.activeElement?.focus();
        }
        this.classList.remove('is-open');
        this.status.textContent = '';
        document.removeEventListener('pointerdown', this.onPointerDown);
        document.removeEventListener('keyup', this.onKeyUp);
      }

      render(item) {
        const image = item.featured_image?.url || item.image;
        if (image) {
          const url = new URL(image, window.location.origin);
          url.searchParams.set('width', 160);
          this.image.src = url.toString();
        } else {
          this.image.removeAttribute('src');
        }

        this.productTitle.textContent = item.product_title;
        this.options.textContent = item.product_has_only_default_variant
          ? ''
          : (item.options_with_values || []).map((option) => `${option.name}: ${option.value}`).join(', ');
        this.price.textContent = window.Shopify?.formatMoney
          ? Shopify.formatMoney(item.final_price, this.dataset.moneyFormat)
          : '';

        // The drawer has just been re-rendered with the new cart, so its totals are current.
        const drawer = document.querySelector('.section-cart-drawer #CartDrawer');
        const count = drawer?.querySelector('.drawer__count')?.textContent.trim();
        this.count.textContent = count ? `(${count})` : '';
        this.total.textContent = drawer?.querySelector('.totals__subtotal-value')?.textContent.trim() || '';
      }

      position() {
        const bag = document.getElementById('cart-icon-bubble')?.getBoundingClientRect();
        if (!bag?.width) return;
        this.style.setProperty('--atb-toast-top', `${Math.round(Math.max(0, bag.bottom))}px`);
        this.style.setProperty('--atb-toast-right', `${Math.round(document.documentElement.clientWidth - bag.right)}px`);
      }

      startTimer() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.hide(), AtbToast.DURATION[this.dataset.arm]);
      }

      isOpen() {
        return this.classList.contains('is-open');
      }

      onPointerDown(event) {
        if (!this.panel.contains(event.target)) this.hide();
      }

      onKeyUp(event) {
        if (event.key === 'Escape') this.hide();
      }

      track(action) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'atb_toast', atb_toast_arm: this.dataset.arm, atb_toast_action: action });
      }
    }
  );
}
